import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserWithdrawal`;

const ApiUserWithdrawal = {
  getAllUserWithdrawal: (params) => {
    
    const url = `${baseServiceUrl}/getAllUserWithdrawal`;
    

    return ServiceApi.get(url, params);
  },
  createUserWithdrawal: (params) => {
    
    const url = `${baseServiceUrl}/createUserWithdrawal`;
    

    return ServiceApi.post(url, params);
  },
};

export default ApiUserWithdrawal;
